import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "tw-text-sm tw-text-gray-500"
}

import { BrandKit } from '@goldcast/api/backend';
import { onMounted, onUnmounted, computed } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';

import BrandKitGoToSelectPrompt from '@/studio/lookAndFeel/components/BrandKitGoToSelectPrompt.vue';
import StudioSelect, { Option } from '@/studioComponents/StudioSelect.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'SelectBrandKit',
  setup(__props) {

const store = useStore();
const router = useRouter();

const brandKits = computed<BrandKit[]>(() => store.state.studioBrandKit.brandKits);
const selectedBrandKit = computed<BrandKit | null>(() => store.state.studioBrandKit.selectedBrandKit);
const brandKitOptions = computed<Option[]>(() =>
  brandKits.value.map(brandKit => ({
    value: brandKit.id!,
    label: brandKit.name
  }))
);
const selectedBrandKitId = computed<string>(() => selectedBrandKit.value?.id || '');
const isLoading = computed<boolean>(() => store.state.studioBrandKit.isLoading);

function refetchBrandKitsOnTabActive() {
  if (!document.hidden) {
    store.dispatch('studioBrandKit/fetchBrandKits');
  }
}

onMounted(() => {
  store.dispatch('studioBrandKit/ensureBrandKitsLoaded');
  document.addEventListener('visibilitychange', refetchBrandKitsOnTabActive);
});

onUnmounted(() => {
  document.removeEventListener('visibilitychange', refetchBrandKitsOnTabActive);
});

function handleGoToCreateBrandKit() {
  const route = router.resolve({ name: 'Brand-Kit' });
  window.open(route.href, '_blank');
}

function handleBrandKitChange(event: Event) {
  const target = event.target as HTMLSelectElement;
  const selectedKit = brandKits.value.find(bk => bk.id === target.value);
  if (selectedKit) {
    store.commit('studioBrandKit/setSelectedBrandKit', selectedKit);
  }
}

return (_ctx: any,_cache: any) => {
  return (isLoading.value)
    ? (_openBlock(), _createElementBlock("p", _hoisted_1, "Fetching brand kits..."))
    : (brandKits.value.length === 0)
      ? (_openBlock(), _createBlock(BrandKitGoToSelectPrompt, {
          key: 1,
          message: "Create a brand kit to apply your brand's colors, fonts, assets and voice to your registration page and event stage experience.",
          buttonText: "Create Brand kit",
          onGoToSelectBrandKit: handleGoToCreateBrandKit
        }))
      : (_openBlock(), _createBlock(StudioSelect, {
          key: 2,
          id: "brand-kit-select",
          placeholder: "Select a brand kit",
          options: brandKitOptions.value,
          value: selectedBrandKitId.value,
          class: "tw-text-sm",
          onChange: handleBrandKitChange
        }, null, 8, ["options", "value"]))
}
}

})